import { VALID_IDENTIFIER_TYPES } from "../../shared/interfaces";

export const validateIdentifierType = (identifierType: string) => {
    return (VALID_IDENTIFIER_TYPES as readonly string[]).includes(identifierType);
};
